module.exports = __webpack_public_path__ + "img/logo-cn.cfa95633.png";